export default function Donate() {
  const donationTypes = [
    {
      icon: 'fa-heart',
      title: '정기후원',
      description: '매월 일정 금액을 후원하여 지속적인 나눔을 실천합니다',
      link: 'https://www.ihappynanum.com/Nanum/B/T3T4SOHMUI'
    },
    {
      icon: 'fa-hand-holding-heart',
      title: '일시후원',
      description: '원하는 시기에 원하는 금액으로 자유롭게 후원합니다',
      link: 'https://www.ihappynanum.com/Nanum/B/T3T4SOHMUI'
    },
    {
      icon: 'fa-building',
      title: '기업후원',
      description: '기업의 사회적 책임을 함께 실천하는 파트너십을 맺습니다',
      link: 'https://www.ihappynanum.com/Nanum/B/T3T4SOHMUI'
    }
  ];

  return (
    <section className="relative py-32 overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/1b35f382ebe0c7df463eebecda1ae6ae.jpg"
          alt="함께하는 나눔"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-5xl font-bold text-white mb-6 tracking-tight">
            함께 만드는 더 나은 내일
          </h2>
          <p className="text-xl text-white/90 mb-4 font-light">
            여러분의 작은 관심과 참여가<br />
            누군가에게는 큰 희망이 됩니다
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
          {donationTypes.map((type, index) => (
            <div
              key={index}
              className="bg-white/10 backdrop-blur-md rounded-2xl p-8 hover:bg-white/20 transition-all duration-300 border border-white/20 hover:transform hover:-translate-y-2"
            >
              <div className="w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center mb-6 mx-auto">
                <i className={`fas ${type.icon} text-white text-2xl`}></i>
              </div>
              <h3 className="text-2xl font-bold text-white mb-4 text-center">
                {type.title}
              </h3>
              <p className="text-white/90 text-center mb-6 leading-relaxed">
                {type.description}
              </p>
              <a
                href={type.link}
                target={type.link.startsWith('http') ? "_blank" : undefined}
                rel={type.link.startsWith('http') ? "noopener noreferrer" : undefined}
                className="block text-center bg-white text-blue-600 px-6 py-3 rounded-lg font-semibold hover:bg-blue-50 transition-colors whitespace-nowrap cursor-pointer"
              >
                자세히 보기
              </a>
            </div>
          ))}
        </div>

        <div className="text-center">
          <a
            href="https://www.ihappynanum.com/Nanum/B/T3T4SOHMUI"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-4 bg-blue-600 hover:bg-blue-700 text-white px-12 py-5 rounded-full text-xl font-bold transition-all duration-300 hover:transform hover:-translate-y-1 shadow-2xl whitespace-nowrap cursor-pointer"
          >
            <div className="w-12 h-12 bg-orange-500 rounded-full flex items-center justify-center">
              <i className="fas fa-heart text-white text-lg"></i>
            </div>
            <span>지금 후원하기</span>
            <i className="fas fa-arrow-right"></i>
          </a>
        </div>
      </div>
    </section>
  );
}